import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useModalsStore = defineStore('modals', () => {
  const modals = ref({
    auth: {
      value: false,
      props: {
        tab: 'login',
      },
    },
    sportModalStatus: false,
    customModal: null,
  })

  function pushModal(payload) {
    modals.value.customModal = payload
  }

  function setSportModalStatus(payload) {
    modals.value.sportModalStatus = payload
  }

  return {
    // refs
    modals,
    // computed
    //functions
    pushModal,
    setSportModalStatus,
  }
})
